import { useQuery } from '@tanstack/react-query';
import { getUserOnePieceCardOwnerships } from '../services/opCardOwnershipService';
import { useAuth } from '../contexts/AuthContext';

/**
 * Hook to fetch unique locations from user's card collection
 * Aggregates locations from all owned cards and returns sorted unique list
 */
export function useCardLocations() {
  const { isAuthenticated } = useAuth();

  return useQuery({
    queryKey: ['card-locations'],
    queryFn: async () => {
      console.log('[useCardLocations] Fetching locations...');
      // Fetch all One Piece card ownerships
      const ownerships = await getUserOnePieceCardOwnerships();
      console.log('[useCardLocations] Fetched ownerships:', ownerships.length);
      
      // Extract unique locations (filter out empty/undefined)
      const locations = new Set<string>();
      ownerships.forEach(ownership => {
        if (ownership.location && ownership.location.trim()) {
          console.log('[useCardLocations] Found location:', ownership.location);
          locations.add(ownership.location.trim());
        }
      });
      
      // Convert to array and sort alphabetically
      const result = Array.from(locations).sort((a, b) => 
        a.localeCompare(b, undefined, { sensitivity: 'base' })
      );
      console.log('[useCardLocations] Returning locations:', result);
      return result;
    },
    enabled: isAuthenticated,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
